export const LabelDesignerGridPluginSettings: IPluginSettings = {
    name: 'Дизайнер ценников и этикетов',
    mnemocode: 'label_designer_plugin',
    permission: 'LabelDesigner',
    columns: [
    ]
}
